<div class="live-iframe-content">
  <div>
    <div class="widgets">
      <div>
        <div class="sr-widget sr-widget-1"></div>
      </div>
      <iframe *ngIf="this.enableBetGeniusTracker" scrolling="no" id="betgenius-iframe" [src]="this.betgeniustrackerlink" width="100%" height="289"></iframe>
    </div>
  </div>
</div>
